import { useState } from 'react'

import { codeStates, decisions } from '../DraftItemsList/DraftItem/constants'
import { getHsCodeState, getHtsCodeState, isCodeActionable, itemHasHtsCode } from '../DraftItemsList/DraftItem/helpers'

const useDraftItemsDecisions = ({ draftItems, showHts }) => {
  const [itemDecisions, setItemDecisions] = useState({})

  const getHsDecision = itemId => itemDecisions[itemId]?.hs || decisions.pending

  const getHtsDecision = itemId => itemDecisions[itemId]?.hts || decisions.pending

  const acceptHs = itemId => {
    setItemDecisions(prev => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        hs: decisions.accepted,
      },
    }))
  }

  const discardHs = itemId => {
    setItemDecisions(prev => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        hs: decisions.discarded,
        hts: decisions.discarded,
      },
    }))
  }

  const undoHs = itemId => {
    setItemDecisions(prev => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        hs: decisions.pending,
      },
    }))
  }

  const acceptHts = itemId => {
    setItemDecisions(prev => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        hts: decisions.accepted,
      },
    }))
  }

  const discardHts = itemId => {
    setItemDecisions(prev => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        hts: decisions.discarded,
      },
    }))
  }

  const undoHts = itemId => {
    setItemDecisions(prev => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        hts: decisions.pending,
      },
    }))
  }

  const restoreHs = itemId => {
    setItemDecisions(prev => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        hs: decisions.pending,
        hts: decisions.pending,
      },
    }))
  }

  const restoreHts = itemId => {
    setItemDecisions(prev => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        hts: decisions.pending,
      },
    }))
  }

  const isItemCodeManaged = (item, dec) => {
    const hsState = getHsCodeState(item.hs_code, item.proposed_hs_code)
    const hsManaged = !isCodeActionable(hsState) || dec?.hs === decisions.accepted || dec?.hs === decisions.discarded

    if (!showHts || !itemHasHtsCode(item)) return hsManaged

    const htsState = getHtsCodeState(item.hts_code, item.proposed_hts_code)
    const htsManaged =
      dec?.hs === decisions.discarded ||
      !isCodeActionable(htsState) ||
      dec?.hts === decisions.accepted ||
      dec?.hts === decisions.discarded

    return hsManaged && htsManaged
  }

  const isAllManaged =
    draftItems?.length > 0 && draftItems.every(item => isItemCodeManaged(item, itemDecisions[item.id]))

  const acceptedCount = draftItems?.reduce((count, item) => {
    const dec = itemDecisions[item.id]

    const hsState = getHsCodeState(item.hs_code, item.proposed_hs_code)

    if (hsState !== codeStates.match && dec?.hs === decisions.accepted) {
      count++
    }

    if (showHts && itemHasHtsCode(item)) {
      const htsState = getHtsCodeState(item.hts_code, item.proposed_hts_code)

      if (htsState !== codeStates.match && dec?.hts === decisions.accepted) {
        count++
      }
    }

    return count
  }, 0)

  const getAcceptedItems = () => {
    return (draftItems || []).reduce((acc, item) => {
      const dec = itemDecisions[item.id]
      const hsState = getHsCodeState(item.hs_code, item.proposed_hs_code)
      const acceptedHs = hsState !== codeStates.match && dec?.hs === decisions.accepted

      let acceptedHts = false

      if (showHts && itemHasHtsCode(item)) {
        const htsState = getHtsCodeState(item.hts_code, item.proposed_hts_code)
        acceptedHts = htsState !== codeStates.match && dec?.hts === decisions.accepted
      }

      if (acceptedHs || acceptedHts) {
        acc.push({ ...item, acceptedHs, acceptedHts })
      }

      return acc
    }, [])
  }

  return {
    getHsDecision,
    getHtsDecision,
    acceptHs,
    discardHs,
    undoHs,
    acceptHts,
    discardHts,
    undoHts,
    restoreHs,
    restoreHts,
    isAllManaged,
    acceptedCount,
    getAcceptedItems,
  }
}

export default useDraftItemsDecisions
